import { render, staticRenderFns } from "./SettingsHome.vue?vue&type=template&id=7180bd46&scoped=true"
import script from "./SettingsHome.vue?vue&type=script&lang=js"
export * from "./SettingsHome.vue?vue&type=script&lang=js"
import style0 from "./SettingsHome.vue?vue&type=style&index=0&id=7180bd46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7180bd46",
  null
  
)

export default component.exports